import React, { useRef, useState } from 'react';
import { InformationCircleIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import DrawerPortal from '../../../Common/SidebarDrawer/DrawerPortal';
import PortalModal from '../../../Common/Modal/PortalModal';
import UpdateCustomerForm from '../Forms/UpdateCustomerForm';
import DeleteCustomerForm from '../Forms/DeleteCustomerForm';


const CustomersRowActions = ({ table, row }) => {
    const drawerRef = useRef(null);
    const modalRef = useRef(null);

    const handleDrawer = (e) => {
        e.stopPropagation()
        if (drawerRef.current) {
            drawerRef.current.showDrawer();
        }
    };


    const updateCustomer = (values) => {
        table.options.meta?.updateCustomerRow(row.original.id, values);
    }


    return (
        <>
            <div className='flex space-x-2'>
                <PencilIcon className="h-5 w-5 cursor-pointer text-base-content/50 hover:text-primary  transition-all duration-300" onClick={handleDrawer} />
            </div>
            <DrawerPortal ref={drawerRef}>
                <UpdateCustomerForm customer={row.original} updateCustomer={updateCustomer} />
            </DrawerPortal>

        </>
    );
};

export default CustomersRowActions;
